import fm from 'front-matter';

const modules = import.meta.glob('/src/content/blog/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
});

const posts = Object.entries(modules)
  .map(([filepath, raw]) => {
    const { attributes, body } = fm(raw);
    return { ...attributes, body };
  })
  .sort((a, b) => new Date(b.date) - new Date(a.date));

export function getAllPosts() {
  return posts;
}

export function getPostBySlug(slug) {
  return posts.find((p) => p.slug === slug) || null;
}

export function getPostsByTag(tag) {
  return posts.filter((p) => p.tags && p.tags.includes(tag));
}
